import { useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { CheckCircle2, XCircle, Loader2, Stethoscope } from "lucide-react";
import { toast } from "sonner";

// Nur lesende sevDesk-Prüfungen (Admin).
export const SevdeskDiagnose = () => {
  const [res, setRes] = useState(null);
  const [busy, setBusy] = useState(false);
  const run = async () => {
    setBusy(true);
    try { const r = await api.get("/integrationen/sevdesk/diagnose"); setRes(r.data); }
    catch (e) { toast.error(e?.response?.data?.detail || "Diagnose fehlgeschlagen."); }
    finally { setBusy(false); }
  };
  return (
    <div className="space-y-2" data-testid="sevdesk-diagnose">
      <Button variant="outline" size="sm" onClick={run} disabled={busy} data-testid="sevdesk-diagnose-button">
        {busy ? <Loader2 className="w-4 h-4 mr-1 animate-spin" /> : <Stethoscope className="w-4 h-4 mr-1" />} sevDesk-Diagnose
      </Button>
      {res && (
        <ul className="text-xs border border-slate-200 rounded-md divide-y divide-slate-100" data-testid="sevdesk-diagnose-result">
          {res.checks.map((c, i) => (
            <li key={i} className="flex items-start gap-2 px-3 py-1.5" data-testid={`sevdesk-diagnose-check-${i}`}>
              {c.ok ? <CheckCircle2 className="w-3.5 h-3.5 text-emerald-600 mt-0.5" /> : <XCircle className="w-3.5 h-3.5 text-rose-600 mt-0.5" />}
              <span className="font-medium min-w-[220px]">{c.check}</span><span className="text-slate-600 break-all">{c.detail}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
